export function bindEvent(element, eventName, eventHandler) {
	if (element.addEventListener) {
	  element.addEventListener(eventName, eventHandler, false)
	} else if (element.attachEvent) {
	  element.attachEvent(`on${eventName}`, eventHandler)
	}
}